import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import { persons } from 'models/persons'; // Importing persons model
import { getColor } from 'helpers/chartcolors'; // Importing color helper function

/**
 * MoneyView class extending JetView to create a chart view.
 */
export default class MoneyView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} Configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service for text
        return {
            type: 'clean', // Clean layout type
            rows: [
                {
                    template: _('Top clients'), // Header template with localized text
                    type: 'header', // Header type
                    css: 'webix_header chart_header', // CSS class for styling
                },
                {
                    view: 'chart', // Chart component
                    type: 'bar', // Bar chart type
                    localId: 'chart', // Local ID for referencing the chart
                    border: false, // No border around the chart
                    radius: 0, // No rounded corners
                    color: () => getColor(), // Dynamic color assignment using getColor function
                    barWidth: 24, // Width of the bars in the chart
                    padding: {
                        top: 5, // Padding on top
                        left: 60, // Padding on left
                    },
                    value: '#money#', // Field to display on the bars
                    xAxis: {
                        template: '#lname#', // Template for x-axis labels
                        lines: false, // No lines on x-axis
                        color: '#EDEFF0', // Color of x-axis
                    },
                    yAxis: {
                        start: 1000, // Starting value for y-axis
                        end: 1500, // Ending value for y-axis
                        step: 100, // Step value for y-axis
                        color: '#fff', // Color of y-axis labels
                        lineColor: '#EDEFF0', // Color of y-axis line
                    },
                    tooltip: {
                        template: '<b>#fname# #lname#</b><br>$#money#', // Tooltip template for displaying data
                    },
                },
            ],
        };
    }

    /**
     * Initializes the view and synchronizes the chart with the persons model.
     */
    init() {
        this.$$('chart').sync(persons, function () {
            // Syncing chart with persons data
            this.filter((obj) => obj.money > 1100); // Filtering data where money is greater than 1100
            this.sort('money', 'desc'); // Sorting data by money in descending order
        });
    }
}

// FILE DOCUMENTED
